import { render, staticRenderFns } from "./timeLimitDetail.vue?vue&type=template&id=481395ac&scoped=true"
import script from "./timeLimitDetail.vue?vue&type=script&lang=js"
export * from "./timeLimitDetail.vue?vue&type=script&lang=js"
import style0 from "./timeLimitDetail.vue?vue&type=style&index=0&id=481395ac&prod&lang=scss&scoped=true"
import style1 from "./timeLimitDetail.vue?vue&type=style&index=1&id=481395ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481395ac",
  null
  
)

export default component.exports